export const CounterNames = {
  SYSTEM_UP_TIME: 'sysUpTime',
  ANTENNA_DIRECTION_BEAM_AZIMUTH: 'deviceTwin_reported_antenna_direction_beamAzimuth',
  ANTENNA_DIRECTION_BEAM_ELEVATION: 'deviceTwin_reported_antenna_direction_beamElevation',
  VDL_GAIN_VALUE: 'deviceTwin_reported_VDL_Gain_value',
  HDL_GAIN_VALUE: 'deviceTwin_reported_HDL_Gain_value',
  VUL_GAIN_VALUE: 'deviceTwin_reported_VUL_Gain_value',
  HUL_GAIN_VALUE: 'deviceTwin_reported_HUL_Gain_value'
};

export const AggregationSuffix = {
  STDDEV: 'stddev',
  MIN: 'min',
  MAX: 'max'
};


export const KpiUnits = {
  PanelPower_HPolDL: 'RF Power (dBm)',
  PanelPower_VPolDL: 'RF Power (dBm)',
  PanelPower_HPolUL: 'RF Power (dBm)',
  PanelPower_VPolUL: 'RF Power (dBm)',
  systemTemp: 'Temperature (' + String.fromCharCode(176) + 'C)'
};

// @todo use ChartJS Colors plugin
// @see https://www.chartjs.org/docs/latest/general/colors.html#default-color-palette
export const defaultColors = [
  '#ff853a',
  '#06749f',
  '#909090',
  '#5ebdfd',
  '#ffaf3a',
  '#556e8f',
  '#d1d1d1',
  '#e8e181',
  '#77e4cf',
  '#616161',
  '#00dce9',
  '#007899',
  '#c57100',
  '#00e96a'
];

export const defaultAxisOptions = {
  ticks: {
    color: '#333333',
    font: {
      family: "'Rubik',sans-serif",
      size: 11,
      weight: '300'
    }
  },
  title: {
    display: false,
    color: '#005082',
    font: {
      family: "'Rubik',sans-serif",
      size: 15,
      weight: '300'
    }
  }
};

export const defaultYAxisOptions = {
  ...defaultAxisOptions,
  type: 'linear',
  position: 'left',
  suggestedMax: 0,
  suggestedMin: 0
};

export const defaultXAxisOptions = {
  ...defaultAxisOptions,
  type: 'time',
  position: 'bottom',
  ticks: {
    ...defaultAxisOptions.ticks,
    minUnit: 'minute',
    maxRotation: 0
  }
};

const defaultSegment = {
  borderDash: ({ p0, p1 }) => {
    return p0.skip || p1.skip ? [4, 4] : undefined;
  }
};

export const defaultAreaDataset = {
  type: 'line',
  lineTension: 0,
  fill: 'origin',
  borderWidth: 2,
  pointRadius: 1,
  pointStyle: 'line',
  pointHoverRadius: 2,
  backgroundColor: 'rgba(0, 0, 0, 0.1)',
  spanGaps: true,
  segment: { ...defaultSegment }
};

export const defaultBarDataset = {
  type: 'bar',
  fill: false
};

export const defaultLineDataset = {
  type: 'line',
  lineTension: 0,
  fill: false,
  borderWidth: 2,
  pointRadius: 1,
  pointStyle: 'circle',
  pointHoverRadius: 2,
  backgroundColor: 'rgba(0, 0, 0, 0.1)',
  spanGaps: true,
  segment: { ...defaultSegment }
};

export const defaultAnnotation = {
  type: 'line',
  borderColor: '#06749f',
  borderWidth: 1,
  borderDash: [1, 2]
};

export const legacyChartLayout = {
  padding: {
    right: 0,
    left: 20
  }
};

export const defaultChartLayout = {
  padding: {
    top: 24,
    right: 24,
    bottom: 12,
    left: 24
  }
};

export const defaultChartOptions = {
  animation: false,
  maintainAspectRatio: false,
  responsive: true,
  interaction: {
    intersect: false,
    mode: 'index',
    axis: 'x'
  },
  plugins: {
    legend: {
      display: false
    },
    tooltip: {
      position: 'cursor',
      caretSize: 0,
      caretPadding: 0,
      cornerRadius: 3,
      backgroundColor: '#1d3648',
      padding: 8,
      titleColor: '#ffffff',
      titleFont: {
        family: 'Rubik',
        size: 12,
        weight: 'bold',
        lineHeight: 1.25
      },
      bodyColor: '#ffffff',
      bodyFont: {
        family: 'Rubik',
        size: 12,
        weight: 'normal',
        lineHeight: 1.25
      },
      bodySpacing: 4,
      boxWidth: 12,
      boxHeight: 12,
      boxPadding: 4
    },
    crosshair: {
      borderColor: '#999999',
      borderDash: [4, 4]
    }
  }
};
